/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

import Button from '@material-ui/core/Button';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Auth, I18n } from 'aws-amplify';
import React, { Component } from 'react';
import { ButtonRow, InputRow, SectionBody } from '../AmplifyUI';
import AuthPiece from './AuthPiece';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { SelectValidator } from 'react-material-ui-form-validator';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import NativeSelect from '@material-ui/core/NativeSelect';
import CircularProgress from '@material-ui/core/CircularProgress';
import * as CONFIG from '../../api/config';
import moment from 'moment';
import { logEvent } from "firebase/analytics";
import { analytics } from "../../api/firebase";

// const validateUrl = "https://w5cm0c4xag.execute-api.eu-west-1.amazonaws.com/Prod/public/api/validate";
const validateUrl = CONFIG.QRVerifyUrl + '/validate';
const recreate = CONFIG.QRVerifyUrl + '/recreate';

export default class SignUp extends AuthPiece {



    constructor(props) {
        super(props);
        this.params = new URLSearchParams(window.location.search);
        this.passport = this.params.get('passport');
        this.email = this.params.get('email');
        this.cpr = this.params.get('cpr');
        if (this.passport)
            this.passport = this.passport ? this.passport.trim() : '';
        if (this.email)
            this.email = this.email ? this.email.trim() : '';
        if (this.cpr)
            this.cpr = this.cpr ? this.cpr.trim() : '';

        this._validAuthStates = ['signUp'];
        this.signUp = this.signUp.bind(this);
        this.state = {
            loading: false,
            address_dis: false,
            showField: (this.passport && this.passport != '') ? true : false,
            license_type: '',
            address_type: (this.passport && this.passport != '') ? '201' : '101',

            selected_professional_type: (this.passport && this.passport != '') ? '20' : '10',
            selected_resident_type: (this.passport && this.passport != '') ? '201' : '101',
            expatriate_dis: true
        }
        this.handleChange = this.handleChange.bind(this);
        // this.handleInputChangeManual = this.handleInputChangeManual.bind(this);
        this.moveTop = this.moveTop.bind(this);
        this.userExists = this.userExists.bind(this);
        this.myDivToFocus = React.createRef()

         logEvent(analytics, 'hcp_public_user_navigated', {
            page_name: 'signup_page',
            datetime: new Date().toISOString(),
        });

    }

    componentDidMount() {
        this.setState({ loading: false, })
        if (this.passport && this.passport != '') {
            this.handleInputChangeManual('username', this.passport);
            this.handleInputChangeManual('email', this.email);
        } else if (this.cpr && this.cpr != '') {
            this.handleInputChangeManual('username', this.cpr);
            this.handleInputChangeManual('email', this.email);
        }

    }

    handleChange = name => e => {
        let vals = e.target.value;
        // console.log("this.passport ", this.passport);
        // console.log('name==>', name, "value==>", vals)
        this.setState({ [name]: vals });
        if (name == "license_type" && vals == '10') {
            this.setState({ address_dis: true, selected_professional_type: vals, expatriate_dis: true })
        } else if (name == "license_type") {
            this.setState({ address_dis: false, selected_professional_type: vals, expatriate_dis: false })
        }

        if (name == "address_type" && vals == '201') {

            this.setState({ showField: true, address_type: vals, selected_resident_type: vals })
        } else if (name == "address_type") {
            this.setState({ showField: false, selected_resident_type: vals })
        }
    }

    moveTop() {
        this.setState({ loading: false })
        if (this.myDivToFocus.current) {
            this.myDivToFocus.current.scrollIntoView({
                behavior: "smooth",
                block: "nearest"
            })
        }
    }

    showLoading = () => {
        return <div
            className="loader-view-block">
            <div className="loader-view">
                <CircularProgress />
            </div>
        </div>
    };

    userExists(username) {

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "username": username,
                "delete": false
            })
        };
        fetch(recreate, requestOptions).then(response => response.json())
            .then(result => {
                if (result.status != "failure") {
                    if (result.UserStatus == 'UNCONFIRMED') {
                        this.setState({ loading: false })
                        this.changeState('confirmSignUp', username);
                    } else {
                        this.moveTop();
                        this.error('You have already registered in Mehan. Please click on “Sign In” link.')
                    }
                } else {
                    this.moveTop()
                    this.error('We apologize for any inconvenience caused, but unfortunately the system is currently not available. Please try again later.');
                }
            }).catch(e => {
                this.moveTop()
                this.error('We apologize for any inconvenience caused, but unfortunately the system is currently not available. Please try again later.');
            });
    }

     isNumberKey(evt) {
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)){
            evt.preventDefault()
            return false;
        }else{
           return true;
        }        
    }


    signUp() {
        this.setState({ loading: true })
        console.log("signUp ", this.inputs);

        let { username, password, email, phone_number, country_code, cpr_expiry_date, block_no } = this.inputs;
        // Cognito's InitiateAuth rejects control/zero-width/bidi chars (regex [\p{L}\p{M}\p{S}\p{N}\p{P}]+); strip them and trim before sending.
        username = (username || '')
            .replace(/[\u0000-\u001F\u007F-\u009F\u200B-\u200F\uFEFF]/g, '')
            .trim();
        // console.log(!username.trim().match(/^[0-9a-zA-Z]+$/));
        // if (this.state.selected_resident_type == '201' && (this.passport && this.passport != '')) {
        //     console.log("set username called ", this.passport);
        //     username = this.passport;
        // }
        console.log("country_code ", country_code);

        console.log(email)

        if (!username || username.trim() === ''
            || username.trim().length < 6 || username.trim().length > 12
            || !username.trim().match(/^[0-9a-zA-Z]+$/)) {
            this.error('Invalid Username. Please use your CPR Number/passport No');
            this.moveTop();
            return;
        }

        // if (phone_number && phone_number.toString().length === 8) {
        //     phone_number = '+973' + phone_number.toString();
        //     // console.log(phone_number)
        //     Auth.signUp(username, password, email, phone_number)
        //         .then(() => this.changeState('confirmSignUp', username))
        //         .catch(err => this.error(err));
        // }
        // else {
        //     this.error('Invalid phone number format. Please use a bahrain mobile number format of 5505 50 55');
        // }
        //  console.log(country_code)
        if (country_code != '' && country_code != undefined && country_code == '973' && (phone_number.length > 8 || phone_number.length < 8)) {
            this.error('Invalid phone number format. Please use a bahrain mobile number format of 5505 50 55');
            this.moveTop();
            return;
        }
        console.log('vengitest', country_code, phone_number.length)
        if (country_code != '' && country_code != undefined) {
            console.log('vengitest', country_code, phone_number.length)
            if (phone_number && country_code && country_code.toString().trim().match(/^[0-9]+$/)) {
                phone_number = '+' + country_code + phone_number.toString();
                if(phone_number.match(/^\+[1-9][0-9]{0,24}$/)){
                    if (email != '' && email != undefined) {
                        if (password != '' && password != undefined) {
                            // if (this.state.address_type == '201') {
                            if (this.state.selected_resident_type == '201') {
                                const requestOptions = {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify({
                                        "idNumber": "",
                                        "idCountryCode": "",
                                        "BlobkNumber": block_no,
                                        "CardExpiryDate": moment(cpr_expiry_date).format('YYYY-MM-DD'),
                                        "username_type": "passport",
                                        "passport_number": username,
                                        "e_mail": email
                                    })
                                };
                                fetch(validateUrl, requestOptions).then(response => response.json())
                                    .then(result => {
                                        if (result.status == 'failure') {
                                            this.moveTop()
                                            this.error(result.message);
                                        } else {
                                            Auth.signUp(username, password, email, phone_number)
                                                .then(() => {
                                                    this.setState({ loading: false })
                                                    this.changeState('confirmSignUp', username);

                                                })
                                                .catch(err => {
                                                    if (err.name == 'UsernameExistsException') {
                                                        this.userExists(username);
                                                    } else {
                                                        this.moveTop();
                                                        this.error(err)
                                                    }

                                                });
                                        }

                                    }).catch(e => {
                                        this.moveTop()
                                        this.error('We apologize for any inconvenience caused, but unfortunately the system is currently not available. Please try again later.');
                                        console.log(e);
                                    });

                                /*Auth.signUp(username, password, email, phone_number)
                                    .then(() => this.changeState('confirmSignUp', username))
                                    .catch(err => { 
                                        this.moveTop();
                                        this.error(err); 
                                        }
                                    );*/
                            } else {
                                if ((block_no != '' && block_no != undefined) && (cpr_expiry_date != '' && cpr_expiry_date != undefined)) {
                                    const requestOptions = {
                                        method: 'POST',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify({
                                            "idNumber": username,
                                            "idCountryCode": "",
                                            "BlobkNumber": block_no,
                                            "CardExpiryDate": moment(cpr_expiry_date).format('YYYY-MM-DD'),
                                            "username_type": "cpr",
                                            "passport_number": "",
                                            "e_mail": email
                                        })
                                    };

                                    fetch(validateUrl, requestOptions).then(response => response.json())
                                        .then(result => {
                                            if (result.status == 'failure') {
                                                this.moveTop()
                                                this.error(result.message);
                                            } else {
                                                Auth.signUp(username, password, email, phone_number)
                                                    .then((res) => {
                                                        console.log('check', res);
                                                        this.setState({ loading: false })
                                                        this.changeState('confirmSignUp', username);
                                                    })
                                                    .catch(err => {
                                                        if (err.name == 'UsernameExistsException') {
                                                            this.userExists(username);
                                                        } else {
                                                            this.moveTop();
                                                            this.error(err)
                                                        }
                                                    });
                                            }
                                        }).catch(e => {
                                            this.moveTop()
                                            this.error('We apologize for any inconvenience caused, but unfortunately the system is currently not available. Please try again later.');
                                            console.log(e);
                                        });
                                } else {
                                    this.moveTop()
                                    this.error('Please use your Block No/CPR Expiry Date');
                                }
                            }
                        } else {
                            this.moveTop()
                            this.error('Please enter password');
                        }
                    } else {
                        this.moveTop()
                        this.error('Please enter email');
                    }
                }else{
                    this.moveTop()
                    this.error('Invalid phone number and country code.');
                }

            } else {
                this.moveTop()
                this.error('Invalid phone number format. Please use a bahrain mobile number format of 5505 50 55');
            }
        } else {
            this.moveTop()
            this.error('Please enter country code & mobile no');
        }

    }
    showComponent(theme) {

        const { hide } = this.props;
        if (hide && hide.includes(SignUp)) { return null; }

        return (
            <div className="flex_div" ref={this.myDivToFocus} >
                <div className="login-content text-center" >

                    <div className="logo_main">
                        <img src="/Mehan_logo.png" />
                    </div>


                    <div className="logo-text">NATIONAL HEALTH REGULATORY AUTHORITY</div>
                    <div className="mt-3">
                        <Typography gutterBottom variant="headline" component="h2">
                            {I18n.get('Sign Up Account')}
                        </Typography>

                        <Grid container spacing={16}>
                            {/* <Grid item xs={12}>
                                <FormHelperText htmlFor="username">{I18n.get('CPR Number (Use license holder Passport/CPR)')} <span className="pending-span">*</span>  <span></span></FormHelperText>
                                <InputRow
                                    autoFocus
                                    theme={theme}
                                    key="username"
                                    name="username"
                                    onChange={this.handleInputChange} />
                            </Grid> */}
                            {/* <Grid item xs={12}>

                                <FormControl fullWidth>
                                    <InputLabel>Select</InputLabel>
                                    <Select fullWidth
                                        onChange={this.handleChange}
                                    >
                                        <MenuItem value={10}>Licensed Professionals</MenuItem>
                                        <MenuItem value={20}>Unlicensed Professionals</MenuItem>
                                        <MenuItem value={30}></MenuItem>
                                    </Select>
                                </FormControl>
                                </Grid> */}
                            <Grid item xs={12}>

                                <FormControl fullWidth>
                                    <InputLabel shrink htmlFor="age-native-label-placeholder">
                                        Select
                                    </InputLabel>
                                    <NativeSelect
                                        // value={state.age}
                                        disabled={(this.passport && this.passport != '')}
                                        onChange={this.handleChange('license_type')}
                                        inputProps={{
                                            name: 'license_type',
                                            id: 'age-native-label-placeholder',
                                            value: this.state.selected_professional_type
                                        }}
                                    >

                                        <option ></option>
                                        <option value={10}>Licensed Professional</option>
                                        <option value={20}>Un-Licensed Professional</option>

                                    </NativeSelect>

                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel shrink htmlFor="age-native-label-placeholder">
                                        Select
                                    </InputLabel>
                                    <NativeSelect
                                        // value={state.age}
                                        disabled={(this.passport && this.passport != '')}
                                        onChange={this.handleChange('address_type')}
                                        inputProps={{
                                            name: 'address_type',
                                            id: 'age-native-label-placeholder',
                                            value: this.state.selected_resident_type
                                        }}
                                    >
                                        <option></option>
                                        <option value="101">Citizen/Resident</option>
                                        <option value="201" disabled={this.state.expatriate_dis}>Expatriate</option>

                                    </NativeSelect>

                                </FormControl>
                            </Grid>

                            {/* 
                        <Grid item xs={12}>
                            <FormHelperText htmlFor="username">{I18n.get('License No')} <span className="pending-span">*</span>  <span></span></FormHelperText>
                            <InputRow
                                autoFocus
                                theme={theme}
                                key="username"
                                name="username"
                                onChange={this.handleInputChange} />
                        </Grid>
                        <Grid item xs={12}>
                            <FormHelperText htmlFor="date">{I18n.get('License Expiry Date')} <span className="pending-span">*</span>  <span></span></FormHelperText>
                            <InputRow
                                autoFocus
                                theme={theme}
                                key="date"
                                name="username"
                                onChange={this.handleInputChange}
                                type="date" />
                        </Grid> */}
                            {this.state.showField == false &&
                                <Grid item xs={12}>
                                    <Grid item xs={12}>
                                        <FormHelperText htmlFor="username">{I18n.get('CPR Number')} <span className="pending-span">*</span>  <span></span></FormHelperText>
                                        <InputRow
                                            required={this.state.showField == false ? true : false}
                                            autoFocus
                                            theme={theme}
                                            value={this.cpr}
                                            key="username"
                                            name="username"
                                            onChange={this.handleInputChange} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormHelperText htmlFor="date">{I18n.get('CPR Expiry Date')} <span className="pending-span">*</span>  <span></span></FormHelperText>
                                        <InputRow
                                            autoFocus
                                            theme={theme}
                                            key="date"
                                            name="cpr_expiry_date"
                                            onChange={this.handleInputChange}
                                            onKeyDown={(e) => e.preventDefault()}
                                            type="date" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormHelperText htmlFor="date">{I18n.get('Block No')} <span className="pending-span">*</span>  <span></span></FormHelperText>
                                        <InputRow
                                            autoFocus
                                            theme={theme}
                                            key="block_no"
                                            name="block_no"
                                            onKeyPress={(e) => this.isNumberKey(e)}
                                            InputProps={{
                                                inputProps: {
                                                    maxLength: 4
                                                }
                                            }}
                                            onChange={this.handleInputChange}
                                        />
                                    </Grid> </Grid>}
                            {this.state.showField && <Grid item xs={12}>
                                <FormHelperText htmlFor="username">
                                    {I18n.get('Passport No')} <span className="pending-span">*</span>
                                    <span></span></FormHelperText>
                                <InputRow
                                    value={this.passport}
                                    autoFocus
                                    disabled={(this.passport && this.passport != '')}
                                    theme={theme}
                                    key="username"
                                    name="username"
                                    onChange={this.handleInputChange}
                                />
                            </Grid>}


                            <Grid item xs={12}>
                                <FormHelperText htmlFor="password">{I18n.get('Password ')} <span className="pending-span">*</span></FormHelperText>
                                <InputRow
                                    theme={theme}
                                    type="password"
                                    key="password"
                                    name="password"
                                    onChange={this.handleInputChange} />
                                <div className="passwrd">
                                    <p>The password must meet the following criteria:</p>
                                    <ul>
                                        <li>Must be at least (8) characters long.</li>
                                        <li>Must contain both uppercase and lowercase characters.</li>
                                        <li>Must contain a number.</li>
                                        <li>Must contain a special character.</li>
                                    </ul>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <FormHelperText htmlFor="email">{I18n.get('Email')} <span className="pending-span">*</span></FormHelperText>
                                <InputRow
                                    theme={theme}
                                    value={this.email}
                                    key="email"
                                    name="email"
                                    onChange={this.handleInputChange} />
                            </Grid>
                            {/* <Grid item xs={12}>

                            <FormControl fullWidth>
                                <InputLabel shrink htmlFor="age-native-label-placeholder">
                                    Nationality
                                </InputLabel>
                                <NativeSelect
                                   
                                    onChange={this.handleChange}
                                    inputProps={{
                                        name: 'age',
                                        id: 'age-native-label-placeholder',
                                    }}
                                >
                                    <option value="">None</option>
                                    <option value={10}>Ten</option>
                                    <option value={20}>Twenty</option>
                                    <option value={30}>Thirty</option>
                                </NativeSelect>
                                
                            </FormControl>
                        </Grid> */}

                            {/* <Grid item xs={12}>
                            
                            
                            <FormHelperText htmlFor="phone_number">{I18n.get('Bahrain Mobile Number')} <span className="pending-span">*</span></FormHelperText>
                            <InputRow
                                theme={theme}
                                key="phone_number"
                                name="phone_number"
                                placeholder="55055055"
                                type="number"
                                onChange={this.handleInputChange} />
                        </Grid> */}
                            <Grid item xs={4}>
                                <FormHelperText htmlFor="phone_number" className="pb-12">{I18n.get('Country Code')} <span className="pending-span">*</span></FormHelperText>
                                <InputRow
                                    theme={theme}
                                    key="country_code"
                                    name="country_code"
                                    placeholder="973"
                                    type="number"
                                    InputProps={{
                                        inputProps: {
                                            min: 1,
                                            pattern: '[0-9]*'
                                        }
                                    }}
                                    onChange={this.handleInputChange} />
                            </Grid>

                            <Grid item xs={8}>

                                <FormHelperText htmlFor="phone_number">{I18n.get('Mobile Number(this mobile will be used for sending OTP)')} <span className="pending-span">*</span></FormHelperText>
                                <InputRow
                                    theme={theme}
                                    key="phone_number"
                                    name="phone_number"
                                    placeholder="55055055"
                                    type="number"
                                    onChange={this.handleInputChange} />

                            </Grid>
                        </Grid>
                    </div>

                    <SectionBody>
                        {!this.state.loading && <ButtonRow
                            onClick={this.signUp}
                            theme={theme}>
                            {I18n.get('Sign Up')}
                        </ButtonRow>}
                    </SectionBody>
                    {this.state.loading && this.showLoading()}

                    {/*<SectionFooter>*/}
                    <Grid container spacing={16}>
                        <Grid item xs={8} style={{ paddingTop: "8px", fontSize: "15px", fontWeight: "bold" }}>
                            Already registered?
                            <Button
                                color="secondary"
                                onClick={() => { this.changeState('signIn'); this.setState({ loading: false }); }}>
                                {I18n.get('Sign In')}
                            </Button>
                        </Grid>
                    </Grid>
                    {/*</SectionFooter>*/}
                </div >
            </div>
        )
    }
}
